import { IFaireMoney } from "@faire/web-api/indigofair/data/IFaireMoney";
import { OWF_GRANT_CREDITS } from "@faire/web-api/indigofair/settings/OWF_GRANT_CREDITS";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingOwFGrantMoney = (): IFaireMoney =>
  getSettingValueWithoutAssignment(
    OWF_GRANT_CREDITS,
    IFaireMoney.build({
      amount_cents: 5_000_00,
      currency: "USD",
    })
  );
